import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-services5',
  templateUrl: './section-services5.component.html',
  styleUrls: ['./section-services5.component.css']
})
export class SectionServices5Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
